/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchResultRequestDTOFromJSON, SearchResultRequestDTOToJSON, } from './SearchResultRequestDTO';
/**
 * @export
 */
export const UpdateSearchResultDecisionRequestDTODecisionEnum = {
    Saleable: 'SALEABLE',
    Recheck: 'RECHECK',
    Unsaleable: 'UNSALEABLE'
};
/**
 * Check if a given object implements the UpdateSearchResultDecisionRequestDTO interface.
 */
export function instanceOfUpdateSearchResultDecisionRequestDTO(value) {
    return true;
}
export function UpdateSearchResultDecisionRequestDTOFromJSON(json) {
    return UpdateSearchResultDecisionRequestDTOFromJSONTyped(json, false);
}
export function UpdateSearchResultDecisionRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'decision': json['decision'] == null ? undefined : json['decision'],
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'searchResultIds': json['searchResultIds'] == null ? undefined : json['searchResultIds'],
        'filters': json['filters'] == null ? undefined : SearchResultRequestDTOFromJSON(json['filters']),
    };
}
export function UpdateSearchResultDecisionRequestDTOToJSON(json) {
    return UpdateSearchResultDecisionRequestDTOToJSONTyped(json, false);
}
export function UpdateSearchResultDecisionRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'decision': value['decision'],
        'selectAll': value['selectAll'],
        'searchResultIds': value['searchResultIds'],
        'filters': SearchResultRequestDTOToJSON(value['filters']),
    };
}
